import { Injectable } from '@angular/core';
import {
  collection,
  doc,
  Firestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';

export interface NotificationItem {
  id: string;
  title: string;
  content: string;
  created: any;
  isRead: boolean;
  URL: string;
  userId: string;
  template_notification_id?: string;
  type?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private notificationsSource = new BehaviorSubject<NotificationItem[]>([]);
  notifications$ = this.notificationsSource.asObservable();
  private currentOrderField: 'created' | 'content' = 'created';
  private currentOrderDirection: 'asc' | 'desc' = 'desc';

  constructor(private firestore: Firestore) {}

  setOrder(field: 'created' | 'content', direction: 'asc' | 'desc'): void {
    this.currentOrderField = field;
    this.currentOrderDirection = direction;
    this.getNotifications();
  }

  getNotifications(): void {
    this.unsubscribeSnapshot();
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = userData.uid || '';
    if (!userId) {
      this.notificationsSource.next([]);
      return;
    }
    const ref = collection(this.firestore, 'notifications');
    const q = query(
      ref,
      where('userId', '==', userId),
      orderBy(this.currentOrderField, this.currentOrderDirection),
    );
    this.unsubscribeSnapshot = onSnapshot(
      q,
      (snapshot) => {
        const notifications = snapshot.docs
          .map((doc) => ({ ...(doc.data() as NotificationItem), id: doc.id }))
          .filter((n) => n.type !== 'admin');
        this.notificationsSource.next(notifications);
      },
      (error) => {
        console.error('Error al recuperar las notificaciones:', error);
      },
    );
  }

  async markAsRead(notificationId: string): Promise<void> {
    const notificationDocRef = doc(
      this.firestore,
      `notifications/${notificationId}`,
    );
    try {
      await updateDoc(notificationDocRef, { isRead: true });
    } catch (error) {
      console.error(`Error al marcar la notificación como leída:`, error);
    }
  }

  private unsubscribeSnapshot: () => void = () => {};
}
